// Утилита: очищает профиль от evidence-объектов перед рендером React
// Evidence-объекты {confidence, pattern, quotes, ...} нельзя рендерить напрямую

function isEvidenceObj(v) {
  if (!v || typeof v !== 'object' || Array.isArray(v)) return false
  const keys = Object.keys(v)
  return keys.includes('confidence') && (keys.includes('pattern') || keys.includes('quotes'))
}

function evidenceToStr(v) {
  if (typeof v === 'string') return v
  if (v == null) return ''
  return v.pattern || v.value || v.name || v.text || v.strength || ''
}

function sanitizeSection(obj, depth = 0) {
  if (depth > 8 || !obj || typeof obj !== 'object') return obj
  if (Array.isArray(obj)) {
    return obj.map(item => {
      if (isEvidenceObj(item)) return evidenceToStr(item)
      if (typeof item === 'object') return sanitizeSection(item, depth + 1)
      return item
    })
  }
  const result = { ...obj }
  for (const key of Object.keys(result)) {
    const val = result[key]
    if (isEvidenceObj(val)) {
      result[key] = evidenceToStr(val)
    } else if (Array.isArray(val)) {
      result[key] = sanitizeSection(val, depth + 1)
    } else if (val && typeof val === 'object') {
      result[key] = sanitizeSection(val, depth + 1)
    }
  }
  return result
}

export function sanitizeProfile(raw) {
  if (!raw) return raw
  const sections = ['personality', 'personality_data', 'competencies', 'competencies_data',
                    'career', 'career_data', 'motivation', 'motivation_data', 'style_analysis']
  for (const key of sections) {
    if (raw[key]) raw[key] = sanitizeSection(raw[key])
  }
  return raw
}
